// extracted by mini-css-extract-plugin
export default {"whatTypes":"WhatTypes_whatTypes__19Nwg","title":"WhatTypes_title__5pk+2","cards":"WhatTypes_cards__dnJXl","card":"WhatTypes_card__xqqSL","cardHeader":"WhatTypes_cardHeader__JFN5V"};